var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160703",
    "data-name": "Group 160703",
    transform: "translate(-321.072 -592.072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1212",
    "data-name": "Rectangle 1212",
    width: 18,
    height: 18,
    transform: "translate(321.072 592.072)",
    fill: "#ffecd4",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M14.465,5.174l1.1-.4a1,1,0,0,1,1.237.437L17.97,7.244a.994.994,0,0,1-.231,1.287l-.907.751a1.07,1.07,0,0,0-.388.891V10.4a1.146,1.146,0,0,0,.388.891l.907.751a1.013,1.013,0,0,1,.231,1.287L16.8,15.368a1.021,1.021,0,0,1-1.237.437l-1.1-.4a1.126,1.126,0,0,0-.973.107.7.7,0,0,1-.206.107,1.148,1.148,0,0,0-.577.784l-.19,1.155a1,1,0,0,1-1,.841H9.17a1,1,0,0,1-1-.841L7.983,16.4a1.148,1.148,0,0,0-.577-.784c-.066-.033-.14-.082-.206-.107a1.123,1.123,0,0,0-.973-.107l-1.1.4a1,1,0,0,1-1.237-.437L2.721,13.331a1.013,1.013,0,0,1,.231-1.287l.907-.751a1.07,1.07,0,0,0,.388-.891v-.231a1.146,1.146,0,0,0-.388-.891l-.907-.751a1.025,1.025,0,0,1-.239-1.287L3.884,5.207A1.021,1.021,0,0,1,5.121,4.77l1.1.4a1.126,1.126,0,0,0,.973-.107A.7.7,0,0,1,7.4,4.959a1.148,1.148,0,0,0,.577-.784l.19-1.138V3.021a1,1,0,0,1,1-.841h2.351a1,1,0,0,1,1,.841l.058.346",
    transform: "translate(319.723 590.793)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M14.13,11.415A2.705,2.705,0,1,1,11.425,8.71h0A2.693,2.693,0,0,1,14.13,11.4v.016Z",
    transform: "translate(318.647 589.649)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 0.47,
    cy: 0.47,
    r: 0.47,
    transform: "translate(332.307 595.052)",
    fill: "#787f88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhiteIcon);
export default __webpack_public_path__ + "static/media/settings-white-icon.946a46912f19ae0319e7a7e8166bf61b.svg";
export { ForwardRef as ReactComponent };